<template>
	<div>
		<div class="section titles wf-section">
			<div class="container titles w-container">
				<img src="/img/icons/hyper-logo-white.svg" loading="lazy" alt="Hyper wash Stockholm logo" class="logo-footer hyper">
			</div>
		</div>
		<div class="section wf-section">
			<div class="container w-container">
				<div class="w-layout-grid main-grid">
					<div id="w-node-ae74bca1-7a2a-7d20-3579-bd2748f73683-0f8c2979" class="gray-wrapper inner-form-medium">
						<div class="container w-container margin-bottom-xsmall ttl">
							<h1 class="heading-medium">Välkommen tillbaka</h1>
						</div>
						<div class="form-container">
							<div class="form-wrapper left">
								<div class="full-form w-form">
									<form action="#" @submit.prevent="submit" class="inner-form">
										<div class="inner-input">
											<div class="label-form">Email Address</div>
											<input id="email" type="email" class="text-field dark w-input"
												placeholder="Enter your email" maxlength="256" name="email" value
												required autofocus v-model="form.email" />
										</div>
										<div class="inner-input margin-bottom-xsmall">
											<div class="label-form">Password</div>
											<input id="password" type="password" class="text-field dark w-input"
												placeholder="*********" maxlength="256" name="password" required
												v-model="form.password" />
										</div>
										<div class="inner-input flex-horizontal margin-bottom-xsmall">
											<input type="submit" value="Logga in" data-wait="Please wait..."
												class="button color-red w-button">
											<!--<a href="#">Forgot Password?</a>-->
										</div>
									</form>
									<div v-if="error" class="error rounded w-form-fail">
										<div>Oops! Something went wrong - {{ error }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
import firebase from 'firebase/app';
import Footer from "@/components/Footer";

export default {
	name: 'Login',
	components: {
		Footer
	},
	data() {
		return {
			form: {
				email: "",
				password: ""
			},
			error: null
		};
	},
	methods: {
		submit() {
			firebase
				.auth()
				.signInWithEmailAndPassword(this.form.email, this.form.password)
				.then(data => {
					this.$router.replace({ name: "Dashboard" });
				})
				.catch(err => {
					// console.log("err" + err);
					this.error = err.message;
				});
		}
	}
};
</script>
<style scoped>
.section.titles {
	padding-top: 1vh;
}
	.container.titles{
		padding-bottom: 1vh;
	}
.w-form-fail {
	display: block;
}
@media screen and (max-width: 991px) {
	.ttl{
		padding-left:0;
		padding-right:0;
	}
	.section.titles {
		padding-top: 1vh;
	}
	.container.titles{
		padding-bottom: 1vh;
	}
	.gray-wrapper.inner-form-medium {
		padding-top: 2em;
		padding-bottom: 0;
	}
}
</style>
